import localForage from "localforage";

export async function toggleFavoriteGame(userId, gameId) {
    const id = gameId.toString();
    let favoriteGames = await fetchFavoriteGames(userId) || [];
    let idx = favoriteGames.indexOf(id);
    if (idx < 0) {
        favoriteGames.unshift(id);
    } else {
        favoriteGames.splice(idx, 1);
    }

    const key = `com.stargame.selector.${userId}.favoriteGames`;
    return new Promise((resolve, reject) => {
        localForage.setItem(key, favoriteGames).then((value) => {
            resolve(value);
        }).catch((err) => {
            reject(err);
        });
    });
}

export async function saveFavoriteGames(userId, gameIds) {
    const key = `com.stargame.selector.${userId}.favoriteGames`;
    return new Promise((resolve, reject) => {
        localForage.setItem(key, gameIds.map(id => id.toString())).then((value) => {
            resolve(value);
        }).catch((err) => {
            reject(err);
        });
    });
}

export async function fetchFavoriteGames(userId) {
    const key = `com.stargame.selector.${userId}.favoriteGames`;
    return new Promise((resolve, reject) => {
        localForage.getItem(key).then((value) => {
            !value ?
                resolve([]) :
                resolve(value.map(item => item.toString()) || []);
        }).catch((err) => {
            reject(err);
        });
    });
}

export async function addGameToRecent(userId, gameId) {
    const id = gameId.toString();
    let recentGames = await fetchRecentGames(userId) || [];
    let idx = recentGames.indexOf(id);
    if (idx >= 0) {
        recentGames.splice(idx, 1);
    }
    recentGames.unshift(id);
    while (recentGames.length > 50) {
        recentGames.pop();
    }

    const key = `com.stargame.selector.${userId}.recentGames`;
    return new Promise((resolve, reject) => {
        localForage.setItem(key, recentGames).then((value) => {
            resolve(value);
        }).catch((err) => {
            reject(err);
        });
    });
}

export async function fetchRecentGames(userId) {
    const key = `com.stargame.selector.${userId}.recentGames`;
    return new Promise((resolve, reject) => {
        localForage.getItem(key).then((value) => {
            !value ?
                resolve([]) :
                resolve(value.map(id => id.toString()) || []);
        }).catch((err) => {
            reject(err);
        });
    });
}

export async function getSessionParams() {
    const key = `com.stargame.selector.session`;
    return new Promise((resolve, reject) => {
        localForage.getItem(key).then((value) => {
            resolve(value || null);
        }).catch((err) => {
            reject(err);
        });
    });
}

export async function saveSessionParams(params) {
    const key = `com.stargame.selector.session`;
    return new Promise((resolve, reject) => {
        localForage.setItem(key, params).then((value) => {
            resolve(value);
        }).catch((err) => {
            reject(err);
        });
    });
}

export async function getDenomination(userId) {
    const key = `com.stargame.selector.${userId}.denomination`;
    return new Promise(resolve => {
        localForage.getItem(key).then((value) => {
            if (!value || value < 0) {
                value = 0
            }
            resolve(value);
        }).catch(() => {
            resolve(0);
        });
    });
}

export async function saveDenomination(userId, denomination) {
    const key = `com.stargame.selector.${userId}.denomination`;
    return new Promise((resolve) => {
        localForage.setItem(key, denomination).then((value) => {
            resolve(value);
        }).catch(() => {
            resolve(0);
        });
    });
}
